export const copyToClipBoard = (value: string) => {
  return navigator.clipboard.writeText(value)
}
